import * as models from './model';


export interface Filter {
    categories: models.Category[];
    attributes: models.Attribute[];
    displayOrder: models.VisualFilter[];
    pagination: models.IPaginationResponse;
}
